import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import RegisterIcon from "@mui/icons-material/AppRegistration";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import GoogleIcon from "@mui/icons-material/Google";
import GitHubIcon from "@mui/icons-material/GitHub";
import {Link, useNavigate} from "react-router-dom";
import PackagesImage from "./images/packages.png"
import {Form, Controller, useForm} from "react-hook-form"
import React, {useEffect, useState} from "react";
import axios from "axios";
import {Alert, FormControlLabel, FormLabel, Radio, RadioGroup} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import Cookies from "js-cookie";
import {EditTwoTone, ErrorOutline, ErrorOutlineTwoTone, PriorityHighTwoTone, PublishTwoTone} from "@mui/icons-material";


function encodeCredentials(username, password) {
    return btoa(`${username}:${password}`);
}
export default function EditProfile() {
    const [alertSeverity, setAlertSeverity] = useState("info");
    const [alertMsg, setAlertMsg] = useState("Please update your profile:");
    const {register, control} = useForm()
    const [emailAddress, setEmailAddress] = useState("");
    const [token, setToken] = useState("");
    const [data, setData] = useState("");
    const [screenName, setScreenName] = useState("");
    const [password, setPassword] = useState("");

    const navigate = useNavigate();

    useEffect(() => {
        // Retrieve the auth token from the cookie
        const authToken = Cookies.get('auth');
        const emailAddress = Cookies.get('email');
        if (authToken && emailAddress) {
            authUser(authToken).then(r => {
                setToken(authToken);
                setEmailAddress(emailAddress)
                fetchUserDetails(emailAddress)
            } );

        } else {
            window.location.href = './login';
        }
    }, []);


    const handleSubmit = async () => {
        const encodedCredentials = encodeCredentials(emailAddress, password);
        const formData = new URLSearchParams();
        formData.append('token', token);
        formData.append('screen_name', screenName);
        formData.append('pass_hash', encodedCredentials);

        try {
            const response = await axios.post('../api/user/updateProfile', formData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
            navigate("../profile");
        } catch (error) {
            setAlertMsg("The password is invalid.");
            setAlertSeverity("error");
        }
    };

    const fetchUserDetails = async (email) => {
        try {
            const response = await fetch("../api/user/getUser?email=" + email, {
                method: 'GET'
            });
            if (response.ok) {
                setData(await response.json());
            } else {
                window.location.href = './login';
            }
        } catch (error) {
            window.location.href = './login';
        }
    };

    const authUser = async (authToken) => {
        const encodedAuthToken = encodeURIComponent(authToken);
        try {
            const response = await fetch('../api/user/auth?token=' + encodedAuthToken, {
                method: 'GET'
            });
            if (response.ok) {
                await response.json();
            } else {
                window.location.href = './login';
            }
        } catch (error) {
            window.location.href = './login';
        }
    };

    return (

        <div className="Section">
            <div className="SectionLtr">

              <span className='SectionBox'>
                  <span className="SectionHeadingIcon"><EditTwoTone sx={{ fontSize: 43 }}/></span>
                      <span className="SectionHeading">MODIFY</span>
                      <span className="SectionSubHeading">PROFILE</span>
                  <div className="_div_line_dual_grad"></div>
            <Form onSubmit={handleSubmit}
                  onSuccess={() => {
                      setAlertMsg("User created, setting up payment...");
                      setAlertSeverity("success");
                      navigate("../profile", {state: emailAddress});
                  }}
                  onError={() => {
                      setAlertMsg("Email already registered, please try another:");
                      setAlertSeverity("error");

                  }}
                  control={control}>
                  <div className="_inputSection">
                      <div className="Alert">
                          <Alert severity={alertSeverity} className="Alert">{alertMsg}</Alert>
                      </div>
                      <div className="DataEntry">
                        <div className="DataHeading">E-mail</div>
                        <div className="DataBodyThin">{data.emailAddress}</div>
                      </div>
                       <div className="DataEntry">
                        <div className="DataHeading">Screen Name</div>
                        <div className="DataBodyLrg">{data.screenName}</div>
                      </div>
                        <div className="_div_line_dual_grad"></div>
                      <div className="_inputLine">
                          <TextField id="new_screen_name"
                                     label="New screen name" size="small"
                                     onChange={e => setScreenName(e.target.value)}/>
                      </div>

                 <div className="_inputLine">
                          <TextField id="confirm_pass_hash"
                                     label="Confirm password" size="small"
                                     type="password" required
                                     onChange={e => setPassword(e.target.value)}/>
                      </div>
                <div className="_div_line_dual_grad"></div>
                <div className="_button_bar">

                      <span className="_button_holder">
                          <Link to="/profile"><BackButton/></Link>
                      </span>
                       <span className="_button_holder">
                          <RegisterButton/>
                      </span>
                    </div>
                </div>
            </Form>
              </span>

            </div>
        </div>
    );
}


function RegisterButton() {
    return (
        <Button type="submit" variant="contained" startIcon={< PublishTwoTone/>}>
            Submit
        </Button>
    );
}

function BackButton() {
    return (
        <Button type="button" variant="outlined" startIcon={<ArrowBackOutlinedIcon/>} >
            PROFILE
        </Button>
    );
}

function TerminateButton() {
    return (
        <Button type="button" variant="outlined" color="error" startIcon={<ErrorOutlineTwoTone/>} >
            TERMINATE
        </Button>
    );
}

function GitHubButton() {
    return (
        <Button variant="outlined" color="secondary" startIcon={< GitHubIcon/>}>
            GitHub
        </Button>
    );
}

function GoogleButton() {
    const handleGoogleLogin = async () => {
        try {
            // Make a request to the backend server to initiate the Google OAuth2 flow
            const response = await axios.get('/oauth2/authorization/google', {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, PATCH, OPTIONS',
                    'Access-Control-Allow-Headers': 'X-Requested-With, content-type, Authorization',
                },
            });
            window.location.href = response.data.redirectUrl;
        } catch (error) {
            console.error('Error initiating Google login:', error);
        }
    };
    return (
        <Button variant="outlined" color="success" startIcon={<GoogleIcon/>} onClick={handleGoogleLogin}>
            Google
        </Button>
    );
}

